(function () {
    'use strict';

    angular.module("imApp").factory("p2SubscriptionEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 80,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 81,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
